import { useIntl } from 'react-intl';

import { documentsApi } from '@/domain/documents/api';
import { showApiErrorToast } from '@/services/api';
import { useApiMutation } from '@/services/query';
import toast from '@/components/Toast';

// Forward documents by email. Thin pass-through — the caller builds the endpoint
// body. Nothing to invalidate: this endpoint has no read counterpart, and the
// legacy saga put nothing into Redux either.
export const useSendDocumentByEmailMutation = () => {
  const { formatMessage } = useIntl();

  return useApiMutation({
    mutationFn: documentsApi.sendDocumentByEmail,
    onSuccess: (_response, { body }) => {
      // Recipients are read back off the request body, so the toast can never
      // name an address that was not actually sent to.
      const emails = [...body.email_to, ...body.cc].join(', ');
      toast.success(
        formatMessage(
          {
            id: 'form.dialog.sendByEmail.toast.success',
            defaultMessage: 'Document(s) sent to {emails} successfully',
          },
          { emails },
        ),
      );
    },
    onError: (error) => showApiErrorToast(error),
  });
};
